import React, { Fragment, useState } from 'react';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import Slides from 'components/Slides';
import { SlidesContextProvider } from 'components/Slides/SlidesContext';
import { paddingBuilder } from 'styles/themeUtils';
import { maybeFormatMessage } from 'utils/i18nUtils';

import SlideImages from './patterns/SlideImages';
import { TextBreakTypography } from './styles/Typography';
import { BlockHiddenOnMobile } from './styles/BlockHiddenOnMobile';

const slides = [
  { intlKey: 'PARTNERS', leftImage: 'rewards-partners/rewards-partners.jpg' },
  { intlKey: 'HOSTING', leftImage: 'rewards-hosting/rewards-hosting.png' },
  { intlKey: 'SMILES', leftImage: 'rewards-smiles/rewards-smiles.png' },
];

function SectionUseYourPoints() {
  const [currentStep, setCurrentStep] = useState(1);
  const intl = useIntl();

  const handleUpdateSlide = step => {
    setCurrentStep(step);
  };

  return (
    <SlidesContextProvider
      value={{
        slides,
        currentStep,
        updateSlide: handleUpdateSlide,
      }}
    >
      <Section>
        <BlockHiddenOnMobile
          padding={{
            desktop: paddingBuilder.right(0),
          }}
        >
          <SlideImages />
        </BlockHiddenOnMobile>
        <Block>
          <Slides
            renderSlide={({ intlKey }) => (
              <Fragment key={intlKey}>
                <Typography variant="paragraph2" gutterBottom={2}>
                  {maybeFormatMessage(intl, `REWARDS.USAGE.SLIDES.${intlKey}`, 'TITLE')}
                </Typography>

                <TextBreakTypography
                  variant="title"
                  tag="p"
                  color="black.default"
                  intlKey={`REWARDS.USAGE.SLIDES.${intlKey}.TEXT`}
                  intlValues={{
                    a: msg => (
                      <Link
                        href={intl.formatMessage({ id: `REWARDS.USAGE.SLIDES.${intlKey}.LINK` })}
                        color="primary"
                        typographyProps={{
                          variant: 'title',
                        }}
                      >
                        {msg}
                      </Link>
                    ),
                  }}
                />
              </Fragment>
            )}
          />
        </Block>
      </Section>
    </SlidesContextProvider>
  );
}

export default React.memo(SectionUseYourPoints);
